<template>
  <div>
    <!-- toasts message -->
        <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

 
    <supplierForm :formSchema="formSchema" v-on:emitCloseModal="close"></supplierForm>

    <v-card-title>
      <h2> Supplier Information </h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <v-data-table
      v-bind:headers="headers"
      v-bind:items="items"
      v-bind:search="search"
      v-bind:pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ ++(props.index) }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.office }}</td>
        <td class="text-xs-left">{{ props.item.contact_person }}</td>
        <td class="text-xs-left">{{ props.item.phone }}</td>
        <td class="text-xs-left">
           <span v-if="props.item.is_active" class="active">Yes</span>
          <span v-else class="in-active">No</span>
        </td>

        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0"  @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0"  @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>

      <template slot="no-data" class="error">
        <div align="center">No Data Found</div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
let commonService = require("../../../services/common.service");

import supplierForm from "./supplierForm.vue";
export default {
  components: {
    supplierForm
  },

  data: () => ({
    dialog: false,
    totalItems: 0,
    loading: true,
    pagination: {
      sortBy: "id",
      descending: true
    },
    search: "",

    headers: [
      {
        text: "SL",
        align: "left",
        sortable: true,
        value: "id"
      },
      {
        text: "Supplier Name",
        align: "left",
        value: "name"
      },
      {
        text: "Address",
        align: "left",
        value: "office"
      },
      {
        text: "Contact Person",
        align: "left",
        value: "contact_person"
      },
      {
        text: "Contact Number",
        align: "left",
        value: "phone"
      },
      {
        text: "Active",
        align: "left",
        value: "is_active"
      },
      {
        text: "Action",
        align: "center",
        value: ""
      }
    ],

    items: [],

    delete_id: "",
    row_index: "",
    confirmModel: false,
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",

    leaveTypeModal: false,
      formSchema:{
        id:'',
        name:'',
        fax:'',
        office:'',
        contact_person:'',
        phone:'',
        email:'',
        contact_number:'',
        remarks:'',
        is_active: ''
      },  

    queryData: {
      sortBy: "id",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      search_val: ""
    },
    SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },
  }),

  computed: {
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    }
  },

  mounted() {
    this.loadData();
    this.message = "Data loading!";
    this.snackbar = true;
  },

  methods: {
    loadData(pagination) {
      commonService.getAllData("proc_suppliers").then(res => {
        this.items = res.data;
        this.loading = false;
      });
    },

    editItem(index, data) {
        
        this.row_index = index;
        this.formSchema = data;
        window.scrollTo({
          top: 0,
          left: 100,
          behavior: "smooth"
        });
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.confirmModel = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "proc_suppliers").then(res => {
        if (res.status == 1) {
          this.items.splice(row_index, 1);
          this.loadData();
          }
          else
          {          
            this.SnackbarVal.color = "error";
          }
          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;

          this.confirmModel = false;
          this.dialog2 = false;

      });
    },

    close(res) {
     let $this = this;
        if (res.status == 1) {
          if (res.action == "add") {
            $this.items.unshift({ ...res.data });
          }
          if (res.action == "edit") {  
             let findindex = this.items.findIndex((item) => item.id == res.data.id)      
             this.row_index = findindex
             this.$set(this.items, this.row_index, { ...res.data })
             this.row_index = "";
             this.formSchema.id = 0
          }
          window.scrollTo({
          left: 0,
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
            behavior: "smooth"
        });
        }
       
       this.SnackbarVal.message = res.message;
       this.SnackbarVal.snackbar = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/procurement/supplier/supplier_list.vue